export class ChapterConfig{
    path:string
    title:string
    component:Function
    constructor(path:string, title:string, component:Function){
        this.path = path
        this.title = title
        this.component = component
    }
}